import {
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAIL,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_FAIL,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAIL,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAIL,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAIL,
  ATTACH_PRODUCT_IMAGE_SUCCESS,
  ATTACH_PRODUCT_IMAGE_FAIL,
  UPLOAD_PRODUCT_IMAGE_SUCCESS,
  UPLOAD_PRODUCT_IMAGE_FAIL,
  UPDATE_PRODUCT_INVENTORY_SUCCESS,
  UPDATE_PRODUCT_INVENTORY_FAIL,
  CLEAR_PRODUCT_ERROR,
  CLEAR_SELECTED_PRODUCT,
} from "./actionTypes"

const INIT_STATE = {
  products: [],
  selectedProduct: null,
  createdProduct: null,
  pagination: {
    pageIndex: 0,
    pageSize: 10,
    totalCount: 0,
    totalPages: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  },
  loading: false,
  error: null,
  createSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,
  attachImageSuccess: false,
  uploadImageSuccess: false,
  updateInventorySuccess: false,
}

const ProductsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Get all products
    case "GET_PRODUCTS":
      return {
        ...state,
        loading: true,
        error: null,
      }

    case GET_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        products: action.payload.items || [],
        pagination: {
          pageIndex: action.payload.pageIndex,
          pageSize: action.payload.pageSize,
          totalCount: action.payload.totalCount,
          totalPages: action.payload.totalPages,
          hasPreviousPage: action.payload.hasPreviousPage,
          hasNextPage: action.payload.hasNextPage,
        },
        error: null,
      }

    case GET_PRODUCTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }

    // Get single product
    case "GET_PRODUCT":
      return {
        ...state,
        loading: true,
        selectedProduct: null,
        error: null,
      }

    case GET_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedProduct: action.payload,
        error: null,
      }

    case GET_PRODUCT_FAIL:
      return {
        ...state,
        loading: false,
        selectedProduct: null,
        error: action.payload,
      }

    // Create product
    case "CREATE_PRODUCT":
      return {
        ...state,
        loading: true,
        createSuccess: false,
        error: null,
      }

    case CREATE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        createSuccess: true,
        createdProduct: action.payload,
        error: null,
      }

    case CREATE_PRODUCT_FAIL:
      return {
        ...state,
        loading: false,
        createSuccess: false,
        error: action.payload,
      }

    // Update product
    case "UPDATE_PRODUCT":
      return {
        ...state,
        loading: true,
        updateSuccess: false,
        error: null,
      }

    case UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        updateSuccess: true,
        error: null,
      }

    case UPDATE_PRODUCT_FAIL:
      return {
        ...state,
        loading: false,
        updateSuccess: false,
        error: action.payload,
      }

    // Delete product
    case "DELETE_PRODUCT":
      return {
        ...state,
        loading: true,
        deleteSuccess: false,
        error: null,
      }

    case DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSuccess: true,
        error: null,
      }

    case DELETE_PRODUCT_FAIL:
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
        error: action.payload,
      }

    // Attach product image
    case "ATTACH_PRODUCT_IMAGE":
      return {
        ...state,
        loading: true,
        attachImageSuccess: false,
        error: null,
      }

    case ATTACH_PRODUCT_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        attachImageSuccess: true,
        error: null,
      }

    case ATTACH_PRODUCT_IMAGE_FAIL:
      return {
        ...state,
        loading: false,
        attachImageSuccess: false,
        error: action.payload,
      }

    // Upload product image
    case "UPLOAD_PRODUCT_IMAGE":
      return {
        ...state,
        loading: true,
        uploadImageSuccess: false,
        error: null,
      }

    case UPLOAD_PRODUCT_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        uploadImageSuccess: true,
        error: null,
      }

    case UPLOAD_PRODUCT_IMAGE_FAIL:
      return {
        ...state,
        loading: false,
        uploadImageSuccess: false,
        error: action.payload,
      }

    // Update product inventory
    case "UPDATE_PRODUCT_INVENTORY":
      return {
        ...state,
        loading: true,
        updateInventorySuccess: false,
        error: null,
      }

    case UPDATE_PRODUCT_INVENTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        updateInventorySuccess: true,
        error: null,
      }

    case UPDATE_PRODUCT_INVENTORY_FAIL:
      return {
        ...state,
        loading: false,
        updateInventorySuccess: false,
        error: action.payload,
      }

    // Clear errors and state
    case CLEAR_PRODUCT_ERROR:
      return {
        ...state,
        error: null,
      }

    case CLEAR_SELECTED_PRODUCT:
      return {
        ...state,
        selectedProduct: null,
      }

    default:
      return state
  }
}

export default ProductsReducer